import { render, staticRenderFns } from "./VisitPointCreate.vue?vue&type=template&id=70f433b2&scoped=true"
import script from "./VisitPointCreate.vue?vue&type=script&lang=js"
export * from "./VisitPointCreate.vue?vue&type=script&lang=js"
import style0 from "./VisitPointCreate.vue?vue&type=style&index=0&id=70f433b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f433b2",
  null
  
)

export default component.exports